export const CATEGORIES = {
  All: "All",
  Dev: "Development",
  Ad: "Advertisement",
  Cafe: "Cafe",
  CIBI: "CI/BI",
  IT: "IT",
  Media: "Newmedia",
};
